'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginRedirect = loginRedirect;
exports.embeddedLoginRedirect = embeddedLoginRedirect;

var _AnalyticsActions = require('../../actions/AnalyticsActions');

var _frame = require('../../utils/frame');

var _isFunnel = require('../../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _links = require('../../utils/links');

var _links2 = _interopRequireDefault(_links);

var _loginThroughPopup = require('../../utils/loginThroughPopup');

var _loginThroughPopup2 = _interopRequireDefault(_loginThroughPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loginRedirect(user) {
  (0, _AnalyticsActions.trackEvent)('click', { action: 'click login link', linkLocation: 'footer' });
  setTimeout(function () {
    var email = user.get('email');
    if ((0, _frame.isFramed)() && !_isFunnel2.default.fbCrm()) {
      window.open(_links2.default.login('', email));
    } else if (_isFunnel2.default.fbCrm()) {
      window.location.href = _links2.default.loginFbCrm(window.location.href, email);
    } else {
      var redirectUrl = _links2.default.getLoginRedirectUrl(user);
      window.location.href = _links2.default.login(redirectUrl, email);
    }
  }, 250);
}

function embeddedLoginRedirect(user) {
  var email = user.get('email');
  (0, _AnalyticsActions.trackEvent)('click', { action: 'click login link', linkLocation: 'footer' });
  setTimeout(function () {
    if ((0, _frame.isFramed)() && !_isFunnel2.default.fbCrm()) {
      if (_isFunnel2.default.academy()) {
        (0, _loginThroughPopup2.default)(null, email);
      } else {
        window.open(_links2.default.login('', email));
      }
    } else if (_isFunnel2.default.fbCrm()) {
      window.location.href = _links2.default.loginFbCrm(window.location.href, email);
    } else {
      var redirectUrl = _links2.default.getLoginRedirectUrl(user);
      window.location.href = _links2.default.login(redirectUrl, email);
    }
  }, 250);
}